import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignContactFormComponent } from '../campaign-contact-form/campaign-contact-form.component';
import { PopupService } from '../../../shared/services/popup/popup.service';
import { AiChatbotModalComponent } from '../../../shared/components/ai-chatbot-modal/ai-chatbot-modal.component';

@Component({
    selector: 'app-campaign-connect-cta',
    templateUrl: './campaign-connect-cta.component.html',
    styleUrls: ['./campaign-connect-cta.component.scss'],
    standalone: false
})
export class CampaignConnectCtaComponent implements OnInit {
  @Input() campaignId: number = 1234567890;
  @Input() issuerName: string = 'Hello Campaign';
  @Input() chatbotUrl: string;

  ctaList: {
    icon: string;
    name: string;
    nameVariables?: { [key: string]: string };
    show: () => boolean;
    onClick: () => void;
  }[] = [];

  constructor(
    private readonly modalService: NgbModal,
    private readonly popupService: PopupService,
  ) {}

  ngOnInit(): void {
    this.ctaList = [
      {
        icon: 'robot',
        name: 'campaign.cta.askAIChatbot',
        show: () => !!this.chatbotUrl,
        onClick: () => {
          this.openAIChatbot();
        },
      },
      {
        icon: 'mail',
        name: 'campaign.cta.sendEmail',
        show: () => true,
        onClick: () => {
          this.showContactForm();
        },
      },
      {
        icon: 'phone',
        name: 'campaign.cta.scheduleCall',
        show: () => true,
        onClick: () => {
          // Handle email click here
          console.log('Email clicked!');
        },
      },
      {
        icon: 'chat',
        name: 'campaign.cta.ask',
        nameVariables: {
          issuerName: this.issuerName,
        },
        show: () => true,
        onClick: () => {
          // Handle email click here
          console.log('Email clicked!');
        },
      },
      {
        icon: 'whatsapp',
        name: 'campaign.cta.joinWhatsappGroup',
        show: () => true,
        onClick: () => {
          // Handle email click here
          console.log('Email clicked!');
        },
      },
    ].filter((item) => item.show());
  }

  showContactForm() {
    const modalRef = this.modalService.open(CampaignContactFormComponent, {
      centered: true,
      size: 'md',
    });
    modalRef.componentInstance.campaignId = this.campaignId;
    modalRef.componentInstance.issuerName = this.issuerName;
  }

  openAIChatbot() {
    if (!this.chatbotUrl) {
      return;
    }

    const modalRef = this.modalService.open(AiChatbotModalComponent, {
      centered: true,
      windowClass: 'ai-chatbot-modal',
    });

    modalRef.componentInstance.campaignName = this.issuerName;

    modalRef.result.then(
      (result) => {
        if (result === 'continue') {
          window.open(this.chatbotUrl, '_blank');
        }
      },
      () => {
        // Modal dismissed
      },
    );
  }
}
